"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callbackDictionary = void 0;
var rangeComparisonHandler_1 = require("./rangeComparisonHandler");
var selectComparisonHandler_1 = require("./selectComparisonHandler");
var textComparisonHandler_1 = require("./textComparisonHandler");
var booleanComparisonHandler = function (resultValue, filterValues) {
    if (filterValues === void 0) { filterValues = true; }
    if (typeof resultValue !== "boolean") {
        return false;
    }
    return filterValues === resultValue;
};
exports.callbackDictionary = {
    boolean: booleanComparisonHandler,
    select: selectComparisonHandler_1.selectComparisonHandler,
    range: rangeComparisonHandler_1.rangeComparisonHandler,
    text: textComparisonHandler_1.textComparisonHandler,
};
//# sourceMappingURL=callbackDictionary.js.map